import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import { useDropForgeMintingConfig } from "@/components/drop-forge/drop-forge-config";
import { MEMES_CONTRACT } from "@/constants/constants";
import { formatClaimCost, formatClaimStatus, formatEditionSize } from "@/helpers/manifold-display-helpers";
import { useDropForgeManifoldClaim } from "@/hooks/useDropForgeManifoldClaim";
import { useNftBalance } from "@/hooks/useNftBalance";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "react-tooltip";
import NowMintingStatsItem from "./NowMintingStatsItem";
interface NowMintingStatsGridProps {
  readonly nftId: number;
  readonly floorPrice: string;
}
export default function NowMintingStatsGrid(t0) {
  const $ = _c(34);
  const {
    nftId,
    floorPrice
  } = t0;
  const {
    claim: manifoldClaim
  } = useDropForgeManifoldClaim(nftId);
  const {
    contract
  } = useDropForgeMintingConfig();
  const status = manifoldClaim?.status;
  const isStatusLoading = !manifoldClaim;
  const {
    connectedProfile
  } = useAuth();
  const t1 = connectedProfile?.consolidation_key ?? null;
  const t2 = contract ?? MEMES_CONTRACT;
  let t3;
  if ($[0] !== nftId || $[1] !== t1 || $[2] !== t2) {
    t3 = {
      consolidationKey: t1,
      contract: t2,
      tokenId: nftId
    };
    $[0] = nftId;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    balance,
    isLoading: isBalanceLoading
  } = useNftBalance(t3);
  let t4;
  if ($[4] !== manifoldClaim) {
    t4 = manifoldClaim ? formatClaimStatus(manifoldClaim) : undefined;
    $[4] = manifoldClaim;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const statusLabel = t4;
  const statusTone = manifoldClaim?.isDropComplete ? "ended" : status;
  let t5;
  if ($[6] !== manifoldClaim) {
    t5 = manifoldClaim ? formatEditionSize(manifoldClaim).replace(/\s*\/\s*/, "/") : undefined;
    $[6] = manifoldClaim;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const editionSize = t5;
  let t6;
  if ($[8] !== manifoldClaim) {
    t6 = manifoldClaim ? formatClaimCost(manifoldClaim) : undefined;
    $[8] = manifoldClaim;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const mintPrice = t6;
  const balanceTooltip = balance > 0 ? `SEIZED x${balance}` : "UNSEIZED";
  const showBalance = connectedProfile && !isBalanceLoading;
  let t7;
  if ($[10] !== balance || $[11] !== balanceTooltip || $[12] !== nftId || $[13] !== showBalance) {
    t7 = showBalance && <><span data-tooltip-id={`balance-tooltip-${nftId}`} className="tw-flex tw-cursor-pointer tw-items-center tw-gap-1 tw-rounded tw-bg-iron-800 tw-p-1.5 tw-font-sans tw-leading-none"><FontAwesomeIcon icon={faLayerGroup} className="tw-size-3 tw-text-iron-400" /><span className="tw-text-xs tw-font-medium tw-text-iron-300">{balance}</span></span><Tooltip id={`balance-tooltip-${nftId}`} content={balanceTooltip} place="top" border="1px solid rgba(255, 255, 255, 0.15)" style={{
        backgroundColor: "#26272B",
        color: "white",
        padding: "6px 10px",
        fontSize: "12px",
        fontWeight: 600,
        borderRadius: "6px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)"
      }} /></>;
    $[10] = balance;
    $[11] = balanceTooltip;
    $[12] = nftId;
    $[13] = showBalance;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== editionSize || $[16] !== t7) {
    t8 = <span className="tw-flex tw-items-center tw-gap-2">{editionSize}{t7}</span>;
    $[15] = editionSize;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const editionValue = t8;
  let t9;
  if ($[18] !== editionValue) {
    t9 = <NowMintingStatsItem label="Edition" value={editionValue} />;
    $[18] = editionValue;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== isStatusLoading || $[21] !== statusLabel || $[22] !== statusTone) {
    t10 = <NowMintingStatsItem label="Status" value={statusLabel} status={statusTone} isLoading={isStatusLoading} />;
    $[20] = isStatusLoading;
    $[21] = statusLabel;
    $[22] = statusTone;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== isStatusLoading || $[25] !== mintPrice) {
    t11 = <NowMintingStatsItem label="Mint price" value={mintPrice} isLoading={isStatusLoading} />;
    $[24] = isStatusLoading;
    $[25] = mintPrice;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== floorPrice) {
    t12 = <NowMintingStatsItem label="Floor" value={floorPrice} />;
    $[27] = floorPrice;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t9) {
    t13 = <div className="tw-grid tw-grid-cols-2 tw-gap-x-6 tw-gap-y-4 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/5 tw-pt-4">{t9}{t10}{t11}{t12}</div>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t9;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}